interface DataSetListData {
    transactionDetail: TransactionDetail;
    inquiryDetail: {
        accountId: string;
    };
    responseData: {
        datasets: DataSetList[];
    };
}

interface DataSetList {
    id: number;
    datasetName: string;
    status: string;
}

interface DataSetSourcesList {
    transactionDetail: TransactionDetail;
    inquiryDetail: {
        accountId: string;
    };
    responseData: {
        dataSources: {
            filename: string;
            status: string;
        }[]
    };
}

// For data set form creation - START

interface DataSetData {
    transactionDetail: TransactionDetail;
    inquiryDetail: {
        accountId: string;
    };
    responseData: {
        customerDetails: CustomerDetails;
        sourceDataSet: any; // TBD
        sourceIndexer: {
            columns: string[] | null;
        }
    };
}

interface CustomerDetails {
    enrollmentId: string;
    accountId: string;
    sourceName: string;
    payloadLocation: string;
    updateFrequency: string;
}

interface SourceDataSet {
    [key: string]: [string, string];
}

// For data set form creation - END


// form request for Dataset -


interface DatasetFromRequest {
    customerDetails: {
        enrollmentId: string;
        accountId: string;
        sourceName: string;
        payloadLocation: string;
        updateFrequency: string;
    };
    sourceDataSet: SourceDataSet;
    sourceIndexer: {
        columns: string[];
    }
}
// End dataset form request 

// after dataset creation response
interface DatasetFromResponse {
    transactionDetail: TransactionDetail;
    inquiryDetail: {
        accountId: string;
    };
    responseData: {
        id: string;
        datasetName: string;
        status: string;
        message: string;
    }
}